<!--店铺员工-->
<template>
  <div class="app-container">
    <!--    查询条件区域-->
    <!-- <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px">筛选搜索</span>
      </div>
    </div> -->
    <el-card class="operate-container" shadow="never" style="margin-top: 0px">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="60px" style="text-align: left">
          <el-form-item label="是否管理员" v-if="false" label-width="100px">
            <el-input v-model="queryParam.isAdmin" style="width: 120px"></el-input>
          </el-form-item>
          <el-form-item label="员工手机号:" label-width="100px">
            <el-input v-model="queryParam.phone" placeholder="输入员手机号" style="width: 120px"></el-input>
          </el-form-item>
          <el-form-item label="员工姓名:" label-width="80px">
            <el-input v-model="queryParam.name" placeholder="输入员工姓名" style="width: 120px"></el-input>
          </el-form-item>
          <el-form-item label="职位:">
            <el-input v-model="queryParam.position" placeholder="输入职位" style="width: 120px"></el-input>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="queryParam.employStatu" placeholder="全部" clearable style="width: 140px">
              <el-option v-for="item in employStatusOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 10px">
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查
              询</el-button>
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh"
              @click="handleResetSearch()" style="margin-left: 10px">重 置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="app-container-content">
      <div class="title-container" shadow="never" style="padding-top: 20px">
        <!-- <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px">数据列表</span>
      </div> -->
        <div></div>
        <div class="d-flex">
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-s-custom"
            @click="handleCreateOneDlg()">新增员工</el-button>
            <div class="spec-buton-box mr-1">
              <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-reading"
            @click="handleUpFile()">合同</el-button>
              <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
            </div>
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-s-check"
            @click="handleEmploy()">聘用</el-button>
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-close"
            @click="handleFireDlg()">解雇</el-button>
            <div class="spec-buton-box mr-1">
              <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-refresh"
            @click="handleBackDlg()">回雇</el-button>
            <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />

            </div>
            
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-edit"
            @click="handleAgreementTime(selectRow)">编辑</el-button>
          <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-lock" style="margin-right: 23px"
            @click="handleSettingJob()">设置职位</el-button>
        </div>
      </div>
      <div class="table-container" shadow="never" style="margin-top: 20px">
        <!-- @row-click="rowClick" -->
        <el-table ref="multipleTable" :data="tableData" :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }" highlight-current-row max-height="500"
          @select="handleSelectionChange" v-loading="listLoading" border >
          <el-table-column type="selection"></el-table-column>
          <!-- <el-table-column prop="id" label="编号" width="100"></el-table-column> -->
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="genderDes" label="性别"></el-table-column>
          <el-table-column prop="position" label="职位"></el-table-column>
          <el-table-column prop="workNum" label="员工编号"></el-table-column>
          <el-table-column prop="word" label="员工口令"></el-table-column>
          <el-table-column prop="idCard" label="身份证号"></el-table-column>
          <el-table-column prop="emergencyContactRemark" label="紧急联系人"></el-table-column>
          <el-table-column prop="emergencyContactPhone" label="联系人号码"></el-table-column>
          <el-table-column prop="inputTime" label="录入时间"></el-table-column>
          <!-- <el-table-column
            prop="agreementTime"
            label="合同到期时间"
          ></el-table-column> -->
          <el-table-column prop="agreementTime" label="合同到期状态"></el-table-column>
          <!--        <el-table-column prop="salary" label="薪资" ></el-table-column>-->
          <el-table-column prop="employDes" label="聘用状态"></el-table-column>
          <el-table-column label="操作" width="300px" v-if="false">
            <template slot-scope="scope">
              <el-button v-if="scope.row.employStatu != 2" type="primary" size="small"
                @click="handleCommissonDlg(scope.row)" plain>薪</el-button>
              <el-button v-if="scope.row.employStatu == 3" @click="handleEmploy(scope.row)" type="warning" size="small"
                plain>聘</el-button>
              <el-button v-if="isAdmin == true && scope.row.employStatu == 1" @click="handleFireDlg(scope.row)"
                type="warning" size="small" plain>解</el-button>
              <el-button v-if="isAdmin == true && scope.row.employStatu != 2" @click="handleUpFile(scope.row)"
                type="warning" size="small" plain>合</el-button>
              <el-button v-if="isAdmin == true && scope.row.employStatu == 2" @click="handleFireFile(scope.row)"
                type="warning" size="small" plain>解聘资料</el-button>
              <el-button v-if="isAdmin == true && scope.row.employStatu != 2" @click="handleAgreementTime(scope.row)"
                type="warning" size="small" plain>编辑</el-button>
              <!--<el-button-->
              <!--v-if="scope.row.employStatu == 2"-->
              <!--@click="handleDelete(scope.row)"-->
              <!--type="danger"-->
              <!--size="small"-->
              <!--plain-->
              <!--&gt;删除</el-button-->
              <!--&gt;-->
              <el-button v-if="scope.row.employStatu == 2" @click="handleFollowLog(scope.row)" type="primary" size="small"
                plain>跟进</el-button>
              <el-button v-if="isAdmin == true && scope.row.employStatu == 2" @click="handleRehire(scope.row)"
                type="warning" size="small" plain>回雇</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="baseSalary" label="baseSalary" v-if="false"></el-table-column>
        </el-table>
      </div>
    </div>

    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper" :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize" :page-sizes="queryParam.pageSizes" :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <el-dialog title="配置员工薪资模板" :visible.sync="visibleDlgCommisson" width="50%" center>
      <div class="root-container">
        <el-form :model="commissonParam" label-width="140px">
          <el-form-item label="基础游模板:">
            <el-select v-model="commissonParam.bsCommissonId" placeholder="请选择">
              <el-option v-for="item in bsCommissonList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="亲子游模板:">
            <el-select v-model="commissonParam.cfCommissonId" placeholder="请选择">
              <el-option v-for="item in cfCommissonList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgCommisson = false">取消</el-button>
        <el-button type="primary" @click="updateWorkerCommissonTemplate()">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改员工薪资" :visible.sync="visibleDlgChangeSalary" width="50%" center>
      <div class="root-container">
        <el-form :model="changeSalaryParam" label-width="140px">
          <el-form-item label="员工姓名:">
            <el-input v-model="changeSalaryParam.name" placeholder="输入员工姓名" disabled style="width: 240px"></el-input>
          </el-form-item>
          <el-form-item label="薪资:">
            <el-input-number v-model="changeSalaryParam.salary" placeholder="" style="width: 240px"
              :step="100"></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgChangeSalary = false">取消</el-button>
        <el-button type="primary" @click="visibleDlgChangeSalary = false">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增员工" :visible.sync="visibleDlgAdd" width="1000px" center>
      <div class="root-container">
        <el-form ref="refInputWorker" :model="createParam" :rules="rules" label-width="140px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="员工姓名:" prop="name">
                <el-input style="width: 270px" v-model="createParam.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号:" prop="idCard">
                <el-input style="width: 270px" v-model="createParam.idCard"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="性别:" prop="optionsValue">
                <el-select v-model="createParam.optionsValue" placeholder="请选择" style="width: 270px">
                  <el-option v-for="item in createParam.options" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="紧急联系人:" prop="emergencyContactRemark">
                <el-input style="width: 270px" v-model="createParam.emergencyContactRemark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="手机号:" prop="phone">
                <el-input style="width: 270px" v-model="createParam.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="紧急联系人号码:" prop="emergencyContactPhone">
                <el-input style="width: 270px" v-model="createParam.emergencyContactPhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="员工编号:" prop="workNum">
                <el-input style="width: 270px" v-model="createParam.workNum"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="月薪:" prop="salary">
                <el-input-number style="width: 270px" v-model="createParam.salary" :step="100"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="职位:" prop="position">
                <el-select @change='clickChange' v-model="createParam.position" placeholder="请选择" style="width: 270px">
                  <el-option v-for="item in selectWorkList" :key="item.name" :label="item.name" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="口令:" prop="word">
                <el-input style="width: 270px" v-model="createParam.word"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="12">
              <el-form-item label="权重:" prop="">
                <el-input style="width: 270px" readonly=""></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="合同到期时间:">
                <el-date-picker v-model="createParam.agreementTime" type="date" placeholder="选择日期"
                  value-format="yyyy-MM-dd" style="width: 270px"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
         
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOne('refInputWorker')">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" :visible.sync="visibleAgreementTime" width="1000px" center>
      <div class="root-container">
        <el-form :model="createParam" label-width="140px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="员工姓名:" prop="name">
                <el-input style="width: 270px" v-model="createParam.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号:" prop="phone">
                <el-input style="width: 270px" v-model="createParam.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="性别" prop="">
                <el-select placeholder="请选择" style="width: 270px" disabled>
                  <el-option v-for="item in createParam.options" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号:" prop="idCard">
                <el-input style="width: 270px" v-model="createParam.idCard"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="紧急联系人:" prop="emergencyContactRemark">
                <el-input style="width: 270px" v-model="createParam.emergencyContactRemark"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人手机号:" prop="emergencyContactPhone">
                <el-input style="width: 270px" v-model="createParam.emergencyContactPhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="职位:" prop="position">
                <el-select v-model="createParam.position" placeholder="请选择" style="width: 270px">
                  <el-option v-for="item in storeWorkerPositions" :key="item.name" :label="item.name" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="薪资:" prop="salary">
                <el-input-number style="width: 270px" v-model="createParam.baseSalary" :step="100"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="合同有效期:">
                <el-date-picker v-model="createParam.agreementTime" type="date" placeholder="选择日期"
                  value-format="yyyy-MM-dd" style="width: 270px"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="录入日期:">
                <el-date-picker v-model="createParam.agreementTime" type="date" placeholder="选择日期"
                  value-format="yyyy-MM-dd" style="width: 270px"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-form-item label="合同:" prop="workNum">
            <fileUpload :isShowTip="false" :limit="1" :fileType="['doc', 'xls', 'pdf']" />
          </el-form-item> -->
          <el-form-item label="员工编号:" prop="workNum" v-if="false">
            <el-input style="width: 240px" v-model="createParam.workNum"></el-input>
          </el-form-item>
          <!--<el-form-item label="口令:" prop="word">-->
          <!--<el-input style="width: 240px" v-model="createParam.word"></el-input>-->
          <!--</el-form-item>-->
          <el-form-item label="name:" prop="name" v-if="false">
            <el-input style="width: 240px" v-model="createParam.workerId"></el-input>
          </el-form-item>
          <el-form-item label="id:" prop="id" v-if="false">
            <el-input style="width: 240px" v-model="createParam.id"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUpdateWorkersInfo()">取消</el-button>
        <el-button type="primary" @click="updateWorkersInfo()">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="解聘" :visible.sync="visibleDlgRehire" width="50%" center>
      <div>
        <el-form ref="addForm" :model="addParam" :rules="rules" label-width="120px">
          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="员工姓名" prop="">
                <el-input readonly="" style="width: 270px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号" prop="">
                <el-input readonly="" style="width: 270px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="性别" prop="">
                <el-select placeholder="请选择" style="width: 270px" disabled>
                  <el-option v-for="item in createParam.options" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号" prop="">
                <el-input readonly="" style="width: 270px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="入职时间" prop="">
                <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 270px"
                  disabled></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="解雇原因" prop="followContent">
                <el-input v-model="addParam.followContent" placeholder="解雇原因" style="width: 270px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"></el-col>
          </el-row>
          <el-form-item label="解雇原因" prop="followContent" style="margin-top: 22px;">
            <el-input v-model="addParam.followContent" placeholder="解雇原因" style="width: 270px"></el-input>
          </el-form-item>
          <el-form-item label="文件名" prop="content">
            <el-input v-model="addParam.content" placeholder="文件名"></el-input>
          </el-form-item>
          <el-form-item label="上传文件：" style="margin-top: 12px;">
            <el-upload :action="uploadAction" :headers="importHeaders" :on-success="handleUploadSuccess" :before-upload="handleBeforeUpload" :on-exceed="handleExceed"
              :file-list="fileList" :limit="limit">
              <el-button size="small" type="primary">点击上传</el-button>
              <!--<div slot="tip" class="el-upload__tip">只能上传jpg/png文件,图片文件不超过500kb</div>-->
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgRehire = false">取消</el-button>
        <el-button type="primary" @click="handleAddOne">保存</el-button>
      </span>
    </el-dialog>

    <worker-word :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>

    <template v-if="visibleAgContract">
      <el-dialog title="合同" :visible.sync="visibleAgContract" width="1000px" center>
        
        <UploadContract :queryData="selectRow" :uploadCont="2" />
        <!-- <el-table :data="tableData" :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }" highlight-current-row max-height="500" border>
          <el-table-column prop="" label="ID"></el-table-column>
          <el-table-column prop="" label="文件类型"></el-table-column>
          <el-table-column prop="" label="文件名称"></el-table-column>
          <el-table-column prop="" label="上传时间"></el-table-column>
          <el-table-column width="300" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="visibleAgContract = false">取消</el-button>
          <el-button type="primary" @click="visibleAgContract = false">保存</el-button>
        </span> -->
      </el-dialog>
    </template>

    <template v-if="visibleSetJob">
      <el-dialog title="设置职位" :visible.sync="visibleSetJob" width="1000px" center>
        <el-form ref="addForm" :model="addParam" :rules="rules" label-width="120px">
          <h3 style="margin-bottom: 10px">已有职位</h3>
          <el-row>
            <el-col :span="12" v-for="v in selectWorkList" :key="v.id">
              <el-form-item label="职位名称" prop="">
                <el-input v-model="v.name" readonly="" style="width: 270px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <h3 style="margin: 10px 0px">创建新职位</h3>
          <el-row>
            <el-col :span="12">
              <el-form-item label="职位名称" prop="">
                <el-input v-model="createParams.name" style="width: 270px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="权重" prop="">
                <el-input-number :min="2" :maxlength="10" show-word-limit v-model="createParams.power" placeholder=""
                  style="width: 270px;"></el-input-number>
                <div style="color:red">*权重为0或1则为管理员身份</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="visibleSetJob = false">取消</el-button>
          <el-button type="primary" @click="addposit">保存</el-button>
        </span>
      </el-dialog>
    </template>
  </div>
</template>
<style scoped lang="scss">
/deep/ .el-table th.el-table__cell>.cell {
  // width: 90%;
  height: 100%;
  background: #ecf3fd;
  // border-radius: 8px;
}

/deep/ .el-table__header-wrapper .cell {
  line-height: 45px;
  color: #0d6fb8;
}

/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}

/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}

.dialog_div1 {
  padding-bottom: 14px;
  text-align: right;
}

.dialog_div2 {
  padding-bottom: 14px;
  text-align: left;
}

.dialog_span1 {
  font-size: 15px;
  color: #0d6fb8;
  padding-right: 10px;
}

.dialog_span2 {
  font-size: 14px;
  font-weight: normal;
}

.app-container {
  .operate-container {
    border: none;
  }

  .el-form-item {
    margin-bottom: 10px;
  }

  .root-container {
    .el-form-item {
      margin-bottom: 20px;
    }
  }

  /deep/ .el-card__body {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  &-content {
    background: #ffffff;
    border-radius: 8px;
    margin-top: 20px;
  }

  .table-container {
    border: none;
    border-radius: 0px;

    /deep/ .el-table {
      .el-table__header-wrapper {
        .el-table__cell {
          padding: 0px;
        }
      }
    }
  }

  /deep/ .el-form--inline {
    text-align: initial;
  }
}

/deep/ .el-table {
  .el-table__header-wrapper {
    .el-table__cell {
      padding: 0px;
    }
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  background: #ffffff;
}
</style>

<script>
import {
  delWorker,
  fechListWorkers,
  fileWorker,
  fireWorker,
  inputWorker,
  updateWorkerCommissonTemplate,
  employWorker,
  rehireWorker,
  updateAgreementTime,
  updateWorkersInfo,
  resumeWorker
} from "../../../api/StoreWorkers";
import { selectWorkerPosition, addposition } from "../../../api/storeFront";
import commonUtils from "../../../utils/commonUtils";
import globaldata from "../../../utils/globaldata";
import messageUtils from "../../../utils/messageUtils";
import WorkerWord from "../../../components/WorkerWord/WorkerWord";
import { selectAllCmi } from "../../../api/salary/SalaryCommisson";
import { getStaticData } from "@/api/staticData";
import { getToken } from "@/utils/auth";
import { addFile } from "../../../api/StoreWorkers";
import fileUpload from "@/components/Upload/fileUpload";
import { Loading } from 'element-ui';

import UploadContract from "../../user-by-lesson-card/components/UploadContract";
export default {
  components: { UploadContract, WorkerWord, fileUpload },
  data() {
    return {
      limit:1,
      fileType:['png', 'jpg','pdf'],
      listLoading: true,
      rules: {
        name: [{ required: true, message: "请输入员工姓名", trigger: "blur" }],
        optionsValue: [
          {
            required: true,
            message: "请选择性别",
            trigger: ["blur", "change"],
          },
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        workNum: [
          { required: true, message: "请输入员工编号", trigger: "blur" },
        ],
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],

        emergencyContactRemark: [
          { required: true, message: "请输入紧急联系人", trigger: "blur" },
        ],

        emergencyContactPhone: [
          { required: true, message: "请输入紧急联系方式", trigger: "blur" },
        ],
        position: [
          {
            required: true,
            message: "请选择职位",
            trigger: ["blur", "change"],
          },
        ],
        salary: [
          { required: true, message: "请输入员工月薪", trigger: "blur" },
        ],
        word: [{ required: true, message: "请输入员工口令", trigger: "blur" }],
        content: [{ required: true, message: "请输入文件名", trigger: "blur" }],
        followContent: [
          { required: true, message: "请输入解雇原因", trigger: "blur" },
        ],
      },
      createParams: {},
      //弹窗
      visibleDlgAdd: false,
      visibleDlgFire: false,
      visibleDlgChangeSalary: false,
      visibleDlgCommisson: false,
      visibleDlgRehire: false,

      visibleAgreementTime: false,
      refreshWord: "",
      showWordDlg: false,
      tData: null,
      wordType: 0,
      storeFrontId: globaldata.getAdminStore().storeFrontId,
      addParam: {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        workerId: "",
        path: "",
        content: "",
        followContent: "",
      },
      queryParam: {
        name: "",
        phone: "",
        position: "",
        workNum: "",
        employStatu: 1,
        //分页查询
        pageNum: 1, //当前第几页
        totalPage: 1, //总共页数
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
      commissonParam: {},
      bsCommissonList: [],
      cfCommissonList: [],

      //表单结果
      tableData: [],
      storeWorkerPositions: [],

      //1 添加 2 修改 3 删除
      wordType: 0,
      createParam: {},
      changeSalaryParam: {},

      //删除店铺信息
      fireParam: {
        id: "1",
        name: "",
      },
      employStatusOptions: [
        {
          value: 1,
          label: "聘用中",
        },
        {
          value: 0,
          label: "待资料上传",
        },
        {
          value: 3,
          label: "资料上传完毕",
        },
        {
          value: 2,
          label: "解聘",
        },
      ],
      props: {
        isAdmin: {
          type: Boolean,
          default: false,
        },
      },
      fileList: [],
      uploadAction: process.env.BASE_API + "/upload/common/uploadFile",
      importHeaders: "",
      handleRemoveStorePicIndex: -1,

      selectRow: null,
      visibleAgContract: false,
      visibleSetJob: false,
      selectWorkList:[],
      isVip: globaldata.getAdminStore().isVip,
    };
  },
  created() {
    this.resetCreate();
    globaldata.getStorePosition(this.getStorePosition);
    if (globaldata.getAdminStore().userRole == "adminWorker") {
      this.isAdmin = true;
    }
    let mytoken = getToken();
    this.importHeaders = { Authorization: mytoken };
    // getStaticData("").then((response) => {
    //   let data = response.data;
    //   if (commonUtils.isObjectNull(data)) {
    //     return;
    //   }
    //   this.uploadAction =
    //     data.uploadChildPhotoImageUrl + "/" + this.storeFrontId;
    // });
  },
  mounted() { 
    this.selectWorker()
  },
  methods: {
    
    addposit() {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        ...this.createParams
      }
      addposition(param).then((res) => {
        if (res.code == 20000) {
          messageUtils.successMsg(this, "职位设置成功");
          this.visibleSetJob = false;
          this.selectWorker();
        }
      })
    },
    rowClick(row, column, event) {
      this.selectRow = row;
    },
    resetCreate() {
      this.wordType = 0;
      this.createParam = {
        positionId: '',
        name: "",
        gender: "",
        phone: "",
        workNum: "",
        idCard: "",
        emergencyContactPhone: "",
        emergencyContactRemark: "",
        inputAdminId: "",
        inputTime: "",
        employStatu: "",
        salary: "",
        position: "",
        word: "",
        optionsValue: "",
        options: [
          {
            value: "0",
            label: "男",
          },
          {
            value: "1",
            label: "女",
          },
        ],
      };
    },
    getStorePosition(data) {
      this.storeWorkerPositions = data;
      this.storeWorkerPositions.sort(function (a, b) {
        return a.power - b.power;
      });
      this.flechList();
    },
    selectWorker() {
      selectWorkerPosition({ storeFrontId: globaldata.getAdminStore().storeFrontId, }).then((res) => {
        if (res.code == 20000) {
          this.selectWorkList = res.data
          this.createParams = {}
          // this.visibleSetJob = true;
        }
      })
    },
    flechList() {
      this.listLoading = true;
      let param = {
        phone: this.queryParam.phone,
        name: this.queryParam.name,
        position: this.queryParam.position,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        employStatu: this.queryParam.employStatu,
        pageNum: this.queryParam.pageNum, //当前第几页
        pageSize: this.queryParam.pageSize,
      };
      fechListWorkers(param).then((response) => {
        this.listLoading = false;
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.queryParam.totalPage = data.total;
        this.refreshData(data.list);
      });
    },
    clickChange() {
      this.storeWorkerPositions.forEach((item) => {
        if (item.name == this.createParam.position) {
          this.createParam.positionId = item.id
        }
      })
    },
    //刷新页面数据
    refreshData(list) {
      if (commonUtils.isObjectNull(list)) {
        return;
      }
      let tableDataList = [];
      for (let i = 0; i < list.length; ++i) {
        let genderDes = "男";
        if (list[i].gender == 1) {
          genderDes = "女";
        }
        let employDes = "聘用中";
        if (list[i].employStatu == 2) {
          employDes = "已解雇";
        } else if (list[i].employStatu == 0) {
          employDes = "待资料上传";
        } else if (list[i].employStatu == 3) {
          employDes = "完成资料上传";
        }
        let data = {
          number: i + 1,
          id: list[i].id,
          name: list[i].name,
          gender: list[i].gender,
          phone: list[i].phone,
          workNum: list[i].workNum,
          word: list[i].word,
          idCard: list[i].idCard,
          emergencyContactPhone: list[i].emergencyContactPhone,
          emergencyContactRemark: list[i].emergencyContactRemark,
          inputAdminId: list[i].inputAdminId,
          inputTime: list[i].inputTime,
          employStatu: list[i].employStatu,
          salary: list[i].salary,
          position: list[i].position,
          storeFrontId: list[i].storeFrontId,
          power: this.getPositionPower(list[i].position),
          employDes: employDes,
          baseSalary: list[i].baseSalary,
          genderDes: genderDes,
          cfCommissonId: list[i].cfCommissonId,
          bsCommissonId: list[i].bsCommissonId,
          agreementTime: list[i].agreementTime,
        };
        tableDataList.push(data);
      }

      this.tableData = tableDataList;
      this.tableData.sort(function (a, b) {
        return a.power - b.power;
      });
    },
    getPositionPower(positions) {
      for (let i = 0; i < this.storeWorkerPositions.length; ++i) {
        if (this.storeWorkerPositions[i].name == positions) {
          return this.storeWorkerPositions[i].power;
        }
      }
      return 99999;
    },
    //点击查询按钮
    onBtnSearch() {
      this.flechList();
    },
    handleSelectionChange(selection, val) {
      if (selection.length > 1) {
        let del_row = selection.shift();
        this.$refs.multipleTable.toggleRowSelection(del_row, false);
      }
      this.selectRow = selection[0];
      // this.getConfigItem(selection[0].storeLessonsId);
    },
    // handleSelectionChange(val) {

    //   this.multipleSelection = val;
    // },
    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.flechList();
    },
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
    },
    handleCommissonDlg(row) {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      };
      selectAllCmi(param).then((response) => {
        let list = response.data;
        if (commonUtils.isObjectNull(list)) {
          return;
        }
        this.cfCommissonList = [];
        this.bsCommissonList = [];
        for (let i = 0; i < list.length; ++i) {
          if (list[i].lessonTemplateId === 1) {
            this.cfCommissonList.push(list[i]);
          } else if (list[i].lessonTemplateId === 2) {
            this.bsCommissonList.push(list[i]);
          }
        }
        this.commissonParam = {
          id: row.id,
          cfCommissonId: row.cfCommissonId,
          bsCommissonId: row.bsCommissonId,
        };
      });
      this.visibleDlgCommisson = true;
    },
    updateWorkerCommissonTemplate() {
      let param = {
        id: this.commissonParam.id,
        cfCommissonId: this.commissonParam.cfCommissonId,
        bsCommissonId: this.commissonParam.bsCommissonId,
      };
      updateWorkerCommissonTemplate(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, "配置成功");
        this.visibleDlgCommisson = false;
        this.cfCommissonList = [];
        this.bsCommissonList = [];
        this.flechList();
      });
    },
    handleChangeSalary(row) {
      this.changeSalaryParam = {
        id: row.id,
        name: row.name,
        salary: row.salary,
      };
      this.visibleDlgChangeSalary = true;
    },
    // handleFire(data) {
    //   let param = {
    //     workerId: data.id,
    //     adminWord: data.adminWord,
    //     adminId: globaldata.getAdminStore().id,
    //   };
    //   fileWorker(param).then((response) => {
    //     let date = response.data;
    //     if (commonUtils.isObjectNull(date)) {
    //       return;
    //     }
    //     this.doRefreshWord(false);
    //     messageUtils.successMsg(this, "成功解雇");
    //     this.flechList();
    //   });
    // },
    doEmploy(data) {
      let param = {
        workerId: data.id,
        adminWord: data.adminWord,
        adminId: globaldata.getAdminStore().id,
      };
      employWorker(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.doRefreshWord(false);
        messageUtils.successMsg(this, "成功聘用");
        this.flechList();
      });
    },
    doRehire(data) {
      let param = {
        workerId: data.id,
        adminWord: data.adminWord,
        adminId: globaldata.getAdminStore().id,
      };
      rehireWorker(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.doRefreshWord(false);
        messageUtils.successMsg(this, "成功聘用");
        this.flechList();
      });
    },
    handleEmploy(row) {
      if (commonUtils.isObjectNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请先选择一条信息");
        return false;
      }
      if(this.selectRow.employStatu != 3){
        messageUtils.errorMsg(this, "请先选择状态为资料上传完毕的数据");
        return false;
      }
      this.tData = {
        id: this.selectRow.id,
        // id: row.id,
      };
      this.wordType = 4;
      this.doRefreshWord(true);
    },
    //回雇
    handleRehire(row) {
      this.tData = {
        id: row.id,
      };
      this.wordType = 5;
      this.doRefreshWord(true);
    },
    handleUpFile(row) {
      // this.$router.push({
      //   path: "/StaffManagement/means",
      //   query: { workId: row.id, type: "1" },
      // });
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      if (commonUtils.isObjectNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请先选择一条信息");
        return false;
      }
      this.visibleAgContract = true;
    },
    // 聘用
    handleOffer(){},
    handleFireFile(row) {
      this.$router.push({
        path: "/StaffManagement/means",
        query: { workId: row.id, type: "6" },
      });
    },
    handleDelete(row) {
      this.tData = {
        workerId: row.id,
        adminId: globaldata.getAdminStore().id,
      };
      this.wordType = 3;
      this.doRefreshWord(true);
    },

    handleDel(param) {
      delWorker(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.doRefreshWord(false);
        messageUtils.successMsg(this, response.message);
        this.flechList();
      });
    },
    //合同日期
    handleAgreementTime(row) {
      if (commonUtils.isObjectNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请先选择一条信息");
        return false;
      }
      this.createParam.id = row.id;
      this.createParam.workerId = row.id;
      this.createParam.name = row.name;
      this.createParam.optionsValue = row.gender,
        this.createParam.phone = row.phone,
        this.createParam.workNum = row.workNum,
        this.createParam.idCard = row.idCard,
        this.createParam.emergencyContactPhone = row.emergencyContactPhone,
        this.createParam.emergencyContactRemark = row.emergencyContactRemark,
        this.createParam.baseSalary = row.baseSalary,
        this.createParam.position = row.position,
        //this.createParam.agreementTime = row.agreementTime,
        this.$set(this.createParam, "agreementTime", row.agreementTime);
      // storeFrontId: globaldata.getAdminStore().storeFrontId,
      // inputAdminId: globaldata.getAdminStore().id,
      //         word: this.createParam.word,
      //         adminWord: word,
      this.visibleAgreementTime = true;
    },
    handleSettingJob() {
      this.visibleSetJob = true;

      // this.selectWorker()
    },
    updateAgreementTime() {
      let param = {
        workerId: this.createParam.workerId,
        agreementTime: this.createParam.agreementTime,
      };
      updateAgreementTime(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, "设置成功");
        this.visibleAgreementTime = false;
        this.flechList();
      });
    },
    cancelUpdateWorkersInfo() {
      this.resetCreate();
      this.visibleAgreementTime = false;
    },
    updateWorkersInfo() {
      let param = {
        id: this.createParam.id,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        name: this.createParam.name,
        gender: this.createParam.optionsValue,
        phone: this.createParam.phone,
        workNum: this.createParam.workNum,
        idCard: this.createParam.idCard,
        emergencyContactPhone: this.createParam.emergencyContactPhone,
        emergencyContactRemark: this.createParam.emergencyContactRemark,
        inputAdminId: globaldata.getAdminStore().id,
        baseSalary: this.createParam.baseSalary,
        position: this.createParam.position,
        agreementTime: this.createParam.agreementTime + "",
      };
      console.info(param);
      updateWorkersInfo(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        messageUtils.successMsg(this, "设置成功");
        this.visibleAgreementTime = false;
        this.resetCreate();
        this.selectRow = null
        this.flechList();
      });
    },

    //跟进
    // handleFollow(row) {
    //   this.followParam.workerId = row.id;
    //   this.visibleFollow = true;
    // },
    // createWorkerFollow() {
    //   let param = {
    //     workerId: this.followParam.workerId,
    //     storeFrontId: globaldata.getAdminStore().storeFrontId,
    //     followType: this.followParam.followType,
    //     followContent:this.followParam.followContent,
    //     followWorker:this.followParam.followWorker,
    //   };
    //   createWorkerFollow(param).then((response) => {
    //     let date = response.data;
    //     if (commonUtils.isObjectNull(date)) {
    //       return;
    //     }
    //     messageUtils.successMsg(this, "设置成功")
    //     this.visibleFollow = false;
    //     this.flechList();
    //   });
    // },

    //跟进
    handleFollowLog(row) {
      this.$router.push({
        path: "/StaffManagement/followHis",
        query: { workerId: row.id },
      });
    },

    doRefreshWord(show) {
      this.refreshWord = new Date().getTime();
      this.showWordDlg = show;
    },

    //添加
    handleCreateOneDlg() {
      this.createParam = {
        positionId: '',
        name: "",
        gender: "",
        phone: "",
        workNum: "",
        idCard: "",
        emergencyContactPhone: "",
        emergencyContactRemark: "",
        inputAdminId: "",
        inputTime: "",
        employStatu: "",
        salary: "",
        position: "",
        word: "",
        optionsValue: "",
        options: [
          {
            value: "0",
            label: "男",
          },
          {
            value: "1",
            label: "女",
          },
        ],
      };
      // this.refreshWord = new Date().getTime();
      // this.showWordDlg = false;
      this.visibleDlgAdd = true;
    },
    handleCreateOne(ref) {
      this.$refs[ref].validate((valid) => {
        if (valid) {
          this.doCreateOne("");
        } else {
          return false;
        }
      });
    },

    doCreateOne(word) {
      let param = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        name: this.createParam.name,
        gender: this.createParam.optionsValue,
        phone: this.createParam.phone,
        workNum: this.createParam.workNum,
        idCard: this.createParam.idCard,
        positionId: this.createParam.positionId,
        emergencyContactPhone: this.createParam.emergencyContactPhone,
        emergencyContactRemark: this.createParam.emergencyContactRemark,
        inputAdminId: globaldata.getAdminStore().id,
        baseSalary: this.createParam.salary,
        position: this.createParam.position,
        word: this.createParam.word,
        adminWord: word,
        agreementTime: this.createParam.agreementTime + "",
      };
      inputWorker(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.showWordDlg = false;
        this.resetCreate();
        messageUtils.successMsg(this, "录入成功");
        this.visibleDlgAdd = false;
        this.flechList();
      });
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.fileType) {
        const fileName = file.name.split(".");
        const fileExt = fileName[fileName.length - 1];
        const isTypeOk = this.fileType.indexOf(fileExt) >= 0;
        if (!isTypeOk) {
          this.$message.error(
            `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      this.loadingInstance = Loading.service({
        lock: true,
        text: "正在上传文件，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // this.number++;
      return true;
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    handleUploadSuccess(res, file) {
      if (res.code != 20000) {
        messageUtils.errorMsg(this, res.message);
        return;
      }
      this.loadingInstance.close();
      messageUtils.successMsg(this, "上传成功");

      this.addParam.path = res.data;
    },
    handleFireDlg(row) {
      // this.tData = {
      //   id: row.id,
      // };
      // this.wordType = 2;
      // this.doRefreshWord(true);
      //添加一个
      // this.addParam.workerId = row.id;
      if (commonUtils.isObjectNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请先选择一条信息");
        return false;
      }
      this.visibleDlgRehire = true;
    },
    handleBackDlg(){
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      if (commonUtils.isObjectNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请先选择一条信息");
        return false;
      }
      if(this.selectRow.employStatu == 2){
        let param = {
        workerId: this.selectRow.id,
      };
      resumeWorker(param).then((response) => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.doRefreshWord(false);
        messageUtils.successMsg(this, "成功聘用");
        this.selectRow = null
        this.flechList();
      });

      }else{
        messageUtils.errorMsg(this, "请选择聘用状态未解雇的信息");
        return false;
      }
    },
    handleAddOne() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          console.info(this.addParam);
          let param = {
            storeFrontId: globaldata.getAdminStore().storeFrontId,
            relateId: this.selectRow.id,
            filePath: this.addParam.path,
            content: this.addParam.content,
            followContent: this.addParam.followContent,
          };
          fireWorker(param).then((response) => {
            let code = response.code;
            if (code == 20000) {
              messageUtils.successMsg(this, response.message);
              this.visibleDlgRehire = false;
              this.selectRow = null
              this.flechList();
            } else {
              messageUtils.errorMsg(this, response.message);
            }
          });
          this.addParam = {};
          this.fileList = [];
        }
      });
    },
    handleWord(wordType, tData) {
      //添加
      if (wordType == 1) {
        this.doCreateOne(tData);
      } else if (wordType == 2) {
        //解雇
        // this.handleFire(tData);
      } else if (wordType == 3) {
        //删除
        this.handleDel(tData);
      } else if (wordType == 4) {
        //聘用
        this.doEmploy(tData);
      } else if (wordType == 5) {
        //回雇
        this.doRehire(tData);
      }
    },

    /**
     * 分配权限
     * @param row
     */
    allocMenu(row) { },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/my-store/store-workers/index.vue